import { graphql } from "gatsby";
import React from "react";
import DefaultLayout from "../layouts/default";
import Akkordeon from "../components/Akkordeon/Akkordeon";
import Gallery from "../components/Akkordeon/Gallery";

interface UeberUnsProps {
  data: {
    cms: {
      entry: {
        title: string;
        id: number;
        siteId: number;
        metabeschreibung: string;
      };
    };
  };
}

export const MitarbeiterQuery = graphql`
    query ($id: CMS_QueryArgument, $siteId: CMS_QueryArgument) {
        cms {
            entry(id: [$id], siteId: [$siteId]) {
                title
                id
                siteId
                ... on CMS_galerie_Entry {
                    metaBeschreibung
                    abschlussElemente {
                        ... on CMS_bild2_Entry {
                            bild { url }
                        }
                        ... on CMS_zitat_Entry {
                            zitat
                            autor
                        }
                        ... on CMS_button_Entry {
                            buttonText
                            buttonLinkUrl
                            buttonLinkDatei { url }
                            buttonLinkTelefon
                            buttonLinkEmail
                            buttonIcon
                        }
                        ... on CMS_zentrierterInhaltstext_Entry {
                            inhaltstext
                        }
                    }

                    children {
                        title
                        __typename
                        ... on CMS_galerieSektion_Entry {
                            galerieInhalt {
                                __typename
                                ... on CMS_bild_Entry {
                                    bild { url }
                                    bildBeschreibung
                                }
                            }
                        }
                    }
                }

                ... on CMS_galerieSektion_Entry {
                    galerieInhalt {
                        __typename
                        ... on CMS_bild_Entry {
                            bild { url }
                            bildBeschreibung
                        }
                    }
                }
            }
        }
    }
`;

const UeberUns: React.FC<UeberUnsProps> = ({ data }) => {
  return (
    <DefaultLayout
      siteId={data.cms.entry.siteId}
      description={data.cms.entry.metaBeschreibung}
      title={data.cms.entry.title}
    >
      {data.cms.entry.children.map((entry, index) => (
        <Akkordeon
          title={`<h2>${entry.title}</h2>`}
          open={index === 0 ? true : false}
          key={index}
        >
          <Gallery data={entry} />
        </Akkordeon>
      ))}
    </DefaultLayout>
  );
};

export default UeberUns;
